export default __webpack_public_path__ + "static/policy--img-8757e1d75f4660bcca8f127c38fa48ee.jpg";